import { render, staticRenderFns } from "./MediaGrid.vue?vue&type=template&id=3dd8c47b&"
import script from "./MediaGrid.vue?vue&type=script&lang=js&"
export * from "./MediaGrid.vue?vue&type=script&lang=js&"
import style0 from "./MediaGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/MediaGrid.vue
// module id = null
// module chunks = 